<template>
   <Layout>
      <div class="row">
         <div class="col-12">
            <div class="page-title-box d-flex align-items-center justify-content-between">
               <h4 class="mb-0 font-size-18">Escaparate</h4>
            </div>
         </div>
      </div>
   </Layout>
</template>

<script>
   import Layout from "@/layouts/Main";

   export default {
      name: 'StoreFront',
      components: {
         Layout
      }
   }
</script>
